import React , { useEffect, useState} from "react";
import styled from "styled-components";
import LotusBlog from "./LotusBlog";
import { Loading } from '../../Components/Loading';
import { GetData, PostData } from "../../SendingData";
import TopLotus from "./TopLotus";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    justify-content: center;
    margin-top: 90px;
    padding: 0 70px;
    width: calc(100% - 140px) ;
    @media screen and (max-width: 850px){
        padding: 0 ;
        width: 100%;
    }
`
const LotusAllBlog =(props)=>{
    const [data , setData ] = useState()
    const [loading , setLoading ] = useState(true)
    const [error , setError ] = useState('')
    const lang = localStorage.getItem('lang')
    useEffect(()=>{
        getBlog()
    },[lang])

    const getBlog=()=>{
        GetData(`https://lotusapi.farazandishan.com/api/v1/blog/bm?en_fa=${lang}` ,'' , processGet)
    }
    const processGet=(obj , data)=>{
        let response = JSON.parse(data)
        if(response.status === 'success'){
            setLoading(false)
            setData(response.data)
        }else{
            setError(response.data.message)
        }
    }
    if(loading){
        return ( 
            <Style >
                {/* <TopLotus/> */}
                <Loading/>
            </Style>
        )
    }
    return(
        <Style >
            {/* <TopLotus/> */}
            {data ? <LotusBlog {...props} blogs={data}/> :''}
        </Style>
    )
    
}
export default LotusAllBlog